import React from 'react'
import { useIntl } from 'react-intl'

import { useNavigate } from 'react-router-dom'
import logoWhite from '../../assets/imgs/logos/logoMoureWhite.svg'
import './pageNotFound.scss'

const ERROR_CODE = 404
const PageNotFound = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  return (
    <div className="boxPageNotFound">
      <div className="firstBox">
        <div className="firstBoxContent">
          <img className="imgContent" src={logoWhite} alt="moure" />
          <h3 className="textError">{ERROR_CODE}</h3>
        </div>
      </div>
      <div className="secondBox">
        <div className="pageContent">
          <div className="textPageContent">
            <h3 className="titlePage">
              {intl.formatMessage({ id: 'pageNotFound.title' })}
            </h3>
            <p className="textPage">
              {intl.formatMessage({ id: 'pageNotFound.message' })}
            </p>
          </div>
          <div className="btn-error">
            <button className="btn btn__with-bg-type-3" onClick={navigate(-1)}>
              Volver
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PageNotFound
